import { z } from '@spcc/core'

export const breakdownItemSchema = z.object({
  key: z.string(),
  name: z.string(),
  tons: z.number(),
  count: z.number(),
})

export const dailySalesDataPointSchema = z.object({
  date: z.string(),
  totalTons: z.number(),
  deliveryCount: z.number(),
  breakdown: z.array(breakdownItemSchema).optional(),
})

export const dailySalesResponseSchema = z.object({
  days: z.array(dailySalesDataPointSchema),
  totals: z.object({
    totalTons: z.number(),
    totalDeliveries: z.number(),
    daysWithData: z.number(),
  }),
  lastUpdated: z.string(),
})

export const comparisonPeriodSchema = z.object({
  from: z.string(),
  to: z.string(),
  totalTons: z.number(),
  deliveryCount: z.number(),
})

export const comparisonTimeSeriesPointSchema = z.object({
  label: z.string(),
  currentTons: z.number(),
  previousTons: z.number(),
})

export const comparisonBreakdownSchema = z.object({
  key: z.string(),
  name: z.string(),
  currentTons: z.number(),
  previousTons: z.number(),
  change: z.number(),
  changePercent: z.number(),
})

export const comparisonResponseSchema = z.object({
  current: comparisonPeriodSchema,
  previous: comparisonPeriodSchema,
  change: z.object({ tons: z.number(), percent: z.number() }),
  timeSeries: z.array(comparisonTimeSeriesPointSchema),
  breakdown: z.array(comparisonBreakdownSchema).optional(),
  lastUpdated: z.string(),
})

export const factoryTargetProgressSchema = z.object({
  factoryId: z.string(),
  factoryName: z.string(),
  targetTons: z.number(),
  actualTons: z.number(),
  achievementPercent: z.number(),
  remainingTons: z.number(),
})

export const targetProgressResponseSchema = z.object({
  month: z.string(),
  factories: z.array(factoryTargetProgressSchema),
  totals: z.object({
    targetTons: z.number(),
    actualTons: z.number(),
    achievementPercent: z.number(),
    remainingTons: z.number(),
  }),
  lastUpdated: z.string(),
})

export const monthlyTargetSchema = z.object({
  id: z.number(),
  documentId: z.string(),
  month: z.string(),
  factory: z.object({
    id: z.number(),
    documentId: z.string(),
    name: z.string(),
  }).nullable(),
  targetQuantity: z.number(),
  notes: z.string().optional().nullable(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
})

export function validateDailySalesResponse(data: unknown) {
  return dailySalesResponseSchema.parse(data)
}

export function validateComparisonResponse(data: unknown) {
  return comparisonResponseSchema.parse(data)
}

export function validateTargetProgressResponse(data: unknown) {
  return targetProgressResponseSchema.parse(data)
}
